module.exports = __webpack_public_path__ + "img/fd_noluck_img.5d1c795a.png";